// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--3EQtW","enlargeOnHover":"Card-module--enlargeOnHover--1THUu","animShowModal":"Card-module--animShowModal--a-WLr"};